export const GAMEID_PLACEHOLDER = "__gameid__";
export const MAX_SUMMARY_LENGTH = 200;
